/* eslint-disable react/no-danger */
import React, { useState } from 'react';

import DOMPurify from 'isomorphic-dompurify';

import Button from '@/components/Button';
import { BackButton } from '@/components/PredefinedButtons';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';
import DeactivatedInfoModal from './DeactivatedInfoModal';

type Sailor = {
  clientId: string;
  name: {
    first: string;
    last: string;
  };
  email: string;
  dob: string;
  sex: string;
  citizenship: string;
};

interface StepData {
  bookingNumber: string | undefined;
  sailors: Sailor[];
  noOfGuests?: number;
  showConfirmation?: boolean | undefined;
  selectedDOB?: string;
  isManualEntry?: boolean;
  updateProfileEmail?: boolean;
  reservationDetails?: {
    packageCode: string;
    packageType: string;
    fromDate: string;
    toDate: string;
    isMNVV: boolean;
  };
  firstName?: string;
  user?: {
    clientID?: string;
    lastName: string;
    firstName?: string;
    email?: string;
    birthday?: string;
  };
}

type ReclaimAccountProps = {
  tabId: string;
  onBackClick: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (value: StepData) => void;
};

const ReclaimAccount: React.FC<ReclaimAccountProps> = ({ tabId, onBackClick, onSubmit }) => {
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const appUiData = useAppUiData();
  const infoLinkClick = () => {
    setIsInfoVisible(true);
  };
  const handleInfoModalClose = () => {
    setIsInfoVisible(false);
  };
  const subTitle = appUiData[appUiIds.claimBooking.reclaimScreenSubText];
  return (
    <WizardStep tabId={tabId}>
      <BackButton onClick={onBackClick} className={styles.backButton} />
      <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.title]}</h2>
      <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subTitle) }} className={styles.subtitle} />
      <Button onClick={infoLinkClick} className={styles.whyThisHappenedLink}>
        {appUiData[appUiIds.claimBooking.whyThisHappened]}
      </Button>
      <Button className={styles.buttonClaim} variant="payment-card" onClick={onSubmit} disabled={false}>
        {appUiData[appUiIds.claimBooking.title]}
      </Button>
      <Button onClick={onBackClick} className={styles.cancelLink}>
        {appUiData[appUiIds.commonLabels.cancel]}
      </Button>
      <DeactivatedInfoModal isVisible={isInfoVisible} onClose={handleInfoModalClose} />
    </WizardStep>
  );
};

export default ReclaimAccount;
